export enum WorkOrderStatus {
  Active = 1,
  Canceled = 2,
  Pending = 3,
  InProgress = 4,
  Completed = 5
}
